import './bases.component';
import './edit-basis/edit-basis.component';